import React from "react";
import { Modal, Button } from "react-bootstrap";

const AssignmentTimerCompleteModal = ({ show, onContinue }) => {
  return (
    <Modal show={show} onHide={() => {}} centered>
      <Modal.Header>
        <Modal.Title>Time's Up!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Your answers have been submitted automatically as the time for this assignment has ended.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onContinue}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignmentTimerCompleteModal;